/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { DataTableComp } from '../../components/dataTable';
import { getLocationDetails } from '../../redux/slices/location/locationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import {
  last30Days,
  last30daysbefore30days,
  last60Days
} from '../../components/datePicker/utils';
import { getAnalyticsForLocation } from '../../redux/slices/analytics/plotsData';

import { data } from './demoDataDocument';
import { getUserDetails } from '../../redux/slices/user/userDetails';
import TopPlosts from '../../components/topPosts';
import {
  transferDataForAnalyticsOverallCard,
  transferDataForAnalyticsOverviewCard
} from '../../utils/analytics/analyticsCardsUtils';
import { OverallDevelopmentListCard } from '../../components/analytics/cards/overall_development_list_card';
import { OverviewCard } from '../../components/analytics/cards/overview_card';
import DemographicsMap from '../../components/analytics/demographicsMap';

// import { useLocales } from '../../locales';
const DashboardPage: React.FC = () => {
  // const { translate: t } = useLocales();

  const dispatch = useDispatch();
  // cut config based on platforms
  const {
    isLoading,
    uuid,
    name,
    image,
    platforms,
    platforms_information,
    demo
  } = useSelector((state: any) => state.locationDetails);
  const { locationslug } = useParams();
  useEffect(() => {
    dispatch(getUserDetails() as unknown as AnyAction);
  }, [dispatch]);
  useEffect(() => {
    if (locationslug ?? '')
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
  }, [dispatch, locationslug]);

  const type = 'dashboard_data_for_location';
  const [overviewCardData, setOverviewCardData] = useState(null);
  const [overallCardData, setOverallCarfdData] = useState(null);

  const [error, setError] = useState(false);
  useEffect(() => {
    if (demo) {
      setOverviewCardData(
        transferDataForAnalyticsOverviewCard(data, last30Days)
      );
      setOverallCarfdData(
        transferDataForAnalyticsOverallCard(
          data,
          last30Days,
          last30daysbefore30days
        )
      );
      return;
    }
    // if(demo) {setPlotsData(transferData(demo, newConfigsMap)); return;}
    if (!isLoading && uuid) {
      getAnalyticsForLocation('analytics_for_location', type, uuid, last60Days)
        .then((res) => {
          console.log('Dashboard data fetched:', res);
          const dataCopy1 = JSON.parse(JSON.stringify(res));
          const dataCopy2 = JSON.parse(JSON.stringify(res));
          setError(false);
          setOverviewCardData(
            transferDataForAnalyticsOverviewCard(dataCopy2?.res, last30Days)
          );
          setOverallCarfdData(
            transferDataForAnalyticsOverallCard(
              dataCopy1?.res,
              last30Days,
              last30daysbefore30days
            )
          );
        })
        .catch((err) => {
          console.log(err);
          setError(true);
        });
    }
    const event = new CustomEvent('react-app-loaded', { bubbles: true });
    document.dispatchEvent(event);
  }, [uuid, isLoading]);
  // ---

  return (
    <div className={'container'}>
      <div className="m-2" />
      <div className="d-flex flex-row flex-wrap h-md-300px">
        <div className={'h-100 col-12 col-md-6 pe-2 pb-1'}>
          <OverviewCard
            name={name}
            image={image}
            platforms={platforms}
            platformsInformation={platforms_information}
            data={overviewCardData}
            error={error}
          />
        </div>

        <div className={'h-100 col-12 col-md-6 ps-2 pb-1'}>
          <OverallDevelopmentListCard data={overallCardData} error={error} />
        </div>
      </div>
      <div className="m-2" />
      {/* <div className="m-2" /> */}
      <TopPlosts location={locationslug} />
      <div className="m-2" />
      <DataTableComp location={locationslug} />
      <div className="m-6" />
      {uuid && (
        <DemographicsMap
            locationUuid={uuid}
            locationslug={locationslug}
            showViewMoreButton={true}
          />
      )}
      <div className="m-2" />
    </div>
  );
};
export default DashboardPage;
